





















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class FieldsetButton extends Vue {
  @Prop({ default: "" }) readonly icon!: string;
  @Prop() readonly text!: string;
}
